export class ReliabilityThyPrematureFailureUpdateModel {
  public Id?: number;
  public Batch?: number;
  public ReportId?: number;
  public BeforeRemovalOrderType?: string;
  public BeforeRemovalOrderNumber?: number;
  public BeforeRemovalOrderStatus?: string;
  public BeforeRemovalVendorType?: string;
  public BeforeRemovalVendor?: string;
  public BeforeRemovalCondition?: string;
  public AfterRemovalOrderType?: string;
  public AfterRemovalOrderNumber?: number;
  public AfterRemovalOrderStatus?: string;
  public AfterRemovalVendorType?: string;
  public AfterRemovalVendor?: string;
  public AfterRemovalCondition?: string;
  public AcRemoveDate?: Date;
  public AcReg?: string;
  public AcType?: string;
  public FleetType?: string;
  public PrematureFailureStatus?: number;
  public Reason?: number;
  public OtherReason?: string;
}
